
import { call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { baseApi } from '@/lib/api';
import {
  setAvailableCompetitors,
  setLoading,
  setError,
} from '../slices/competitorsSlice';
import { Provider } from '@/types/product';

export const fetchCompetitors = createAction('competitors/fetchCompetitors');

function* fetchCompetitorsSaga() {
  try {
    yield put(setLoading(true));
    const response = yield call(() =>
      baseApi.get('/products/providers/', {
        params: { page_size: 100 },
      })
    );
    yield put(setAvailableCompetitors(response.data.data.results));
  } catch (error) {
    yield put(setError('Failed to fetch competitors'));
  } finally {
    yield put(setLoading(false));
  }
}

export function* competitorsSaga() {
  yield takeLatest(fetchCompetitors.type, fetchCompetitorsSaga);
}
